import ApiService from './api-service';

const ForecastTrialService = {
  async startReceivablesForecastTrial(shortCode) {
    const body = {
      query: `mutation { startReceivablesForecastTrial }`,
    };

    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data.startReceivablesForecastTrial;
  },

  async requestReceivablesForecastAddon(shortCode) {
    const body = {
      query: `mutation { requestReceivablesForecastAddon }`,
    };

    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data.requestReceivablesForecastAddon;
  },
};

export default ForecastTrialService;
